import React, { Component } from "react";

// Classe qui est appelée par ShowInformationExercise, qui est appelée par Deducer.
// Elle n'est utile que pour les prémisses. Une version plutôt similaire de cette classe doit être ButtonReit.

class ButtonRuleRep extends Component {
  render() {
    return (
      <li
        className={"button-rep " + this.props.className}
        onClick={this.props.useOfAddInferenceSent}
        onMouseOver={this.props.useOfForecastInferenceSent}
        onMouseOut={this.props.resetForecastInferenceSent}
      >
        <p className="infNum-color" style={{ marginRight: "5px" }}>
          {/* même couleur que .inferenceNumber, puisque c'est la même idée, je devrais peut-être fusionner les classnames */}
          {this.props.NumberButton + ". "}
        </p>
        <p className="infIts-color">{this.props.NameButton}</p>
        {/*que cette inférence soit issue des prémisses ou de la déduction ne change rien*/}
      </li>
    );
  }
}

export default ButtonRuleRep;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/ButtonRuleRep.js